<template>
	<div>
		<div v-for="message in contentMessages"
			:key="message.id"
			:class="['messages', { survey: message.recipient === 'provider' }]">
			<div :class="['message', { sent: message.sent || message.status === 'sent' }]">
				<!-- <div class="line">
					<i v-if="message.sent || message.status === 'sent'" class="el-icon-success"></i>
					<i v-if="message.status === 'unverified'" class="el-icon-warning"></i>
				</div> -->
				<div class="scheduled">
					<span class="date">{{ formatDate(message.time) }}</span>
					<img v-if="message.sent || message.status === 'sent'" class="status" src="../icon/greenTick.svg">
					<img v-if="message.status === 'unverified'" class="status" src="../icon/grayTick.svg">
					<span class="time">{{ formatTime(message.time) }}</span>
				</div>
				<!-- <div v-if="Array.isArray(message.confirmation)" class="confirmation">
					<span v-for="(confirm, i) in message.confirmation"
						:key="i">
						<i v-if="confirm != null"
							:key="confirm.channel + i"
							v-bind:class="[
								iconConfirmation(confirm),
								{
									success: confirm.status === 'sent',
									error: confirm.status === 'error'
								}
							]"></i>
					</span>
				</div> -->
				<div class="content" v-for="(messageContent, i) in messageContents(message)" :key="i">
					<span class="title">{{ messageContent.title }}</span>
					<p class="subtitle">{{ messageContent.text }}</p>
					<MessageAttachement
						:message="messageContent"
						:patientId="patient.id"
						:showData="true">
					</MessageAttachement>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ScheduledMessages from '../mixin/messages'
import MessageAttachement from '@/module/patient/card/message/Attachment.vue'

const ICON = {
	email: 'el-icon-message',
	sms: 'el-icon-chat-dot-square',
	apn: 'el-icon-mobile-phone'
}
const TEXT = {
	email: 'Email sent',
	sms: 'SMS sent',
	apn: 'iOS push notification sent',
	fcm: 'Android push notification sent'
}

export default {
	name: 'schedule-message-timeline',
	mixins: [ ScheduledMessages ],

	methods: {
		displayConfirmation(confirm, message) {
			return TEXT[confirm.channel]
		},
		iconConfirmation(confirm) {
			return ICON[confirm.channel]
		},
		messageContents(message) {
			// Batch message support
			if (Array.isArray(message.batch))
				return message.batch
			else
				return [ message ]
		}
	},

	components: {
		MessageAttachement
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
